import axios from 'axios';
import {GlobalUtility} from '../../service/global-utility.service';
import {
  CREW_BOOKING,
  GET_BOOKED_LIST_BY_HOTEL,
  SET_CHECKIN_OR_CHECKOUT,
  IS_EXTEND_BOOKING,
  SET_BOOKED_EXTEND_DATE,
  CHECK_CONFLICT,
  TRANSFER_BOOKED,
  CREW_LATEST_BOOKING,
  GET_ALL_BOOKING_ENCODE, UPDATE_BOOKING_ENCODE,
  VIEW_BOOKING_ENCODE, DELETE_BOOKING_ENCODE,
} from '../../service/constants.service';

const state = {
  booked: {},
  bookings: [],

  newBooking: {
    reservation_id: '',
    booked_check_in: '',
    booked_check_out: '',
    booked_extend_date: '',
    hotel_id: '',
    floor_id: '',
    room_id: '',
    // bed_id : '', built in back-end
  },

  reservation_bookings: [],
};

//mutations
const mutations = {
  set_bookings: (state, params) => {
   state.bookings = params;
  },

  set_booked (state, param) {
    console.log('this is from mutation',param);
    state.booked = param;
  },

  set_new_booking: (state, param) => {
    //todo
  },

  set_update_booked: (state, param) => {
    //todo
  },

  //cancelled
  set_delete_booked: (state, param) => {
    let index = state.bookings.findIndex((booking) => booking.booking_id == param.id);
    state.bookings.splice(index,1);
  },

  set_null_bookings: (state, param) => {
    //todo
  },

  set_newBooking_null: (state) => {
    state.newBooking = {
      reservation_id: '',
      booked_check_in: '',
      booked_check_out: '',
      hotel_id: '',
      floor_id: '',
      room_id: '',
    };
  },

  set_booked_null : (state)=>{
    state.booked = {};
  },

  set_bookings_null : (state) =>{
    state.bookings = [];
  },

  set_reservation_bookings : (state, params) =>{
    state.reservation_bookings = params;
  }
};

//actions
const actions = {

  async getBookedDetails({commit}, param) {
    return await axios.get(`${CREW_BOOKING}/${param}`).then((response)=>{
      console.log(response.data);
      commit('set_booked',response.data);
      commit('set_remarks',response.data.remarks);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Booked Details.');
      return false;
    });
  },

  createBooking({commit}, params) {
    return axios.post(CREW_BOOKING,params).then((response)=>{
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      console.log(error.response.data);
      GlobalUtility.generateResponseMessage(error,'Create Booking');
      return false;
    });
  },

  //todo use this to modify the ,booking use for encoder.
  updateBooking({commit}, param) {},

  //cancel booking,
  deleteBooking({commit}, param) {
    return axios.delete(`${CREW_BOOKING}/${param.booking_id}`).then((response)=>{
      commit('set_delete_booked',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Delete Booking.');
      return false;
    })
  },

  isExtendBooking({commit}, param) {
    return axios.post(IS_EXTEND_BOOKING, param).then((response) => {
      return true;
    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error, 'Request Booked Extend');
      return false;
    });
  },

 async getBookedListByHotel({commit},params){
    return await axios.post(GET_BOOKED_LIST_BY_HOTEL,params).then((response)=>{
      commit('set_bookings',response.data.data);
      commit('set_tnkc_booked_pagination',response.data);
      return true;

    }).catch((error)=>{
      GlobalUtility.generateResponseMessage(error,'Get Booked List');
      return false;
    });
  },

  setNewBookingNull({commit}){
    commit('set_newBooking_null');
  },

  setBookedNull({commit}) {
    commit('set_booked_null');
  },

  setNullInitBookDetails({commit}){
    commit('set_null_init_book_details');
  },

  async setCheckInOrOut({commit},params){
    return await axios.post(SET_CHECKIN_OR_CHECKOUT,params).then((response)=>{
      commit('set_booked',response.data);
      commit('set_remarks',response.data.remarks);
      return true;

    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Set Checkin or Checkout');
      return false;

    });
  },

  setExtendDate({commit},params){
   return axios.post(SET_BOOKED_EXTEND_DATE,params).then((response)=>{
     commit('set_booked',response.data);
     commit('set_remarks',response.data.remarks);
     return true;

   }).catch((error)=>{
     GlobalUtility.failProgressBar();
     GlobalUtility.generateResponseMessage(error,'Set Booked Extend Date');
     return false;

   });
  },

  checkConflict({commit},params){
    return axios.post(CHECK_CONFLICT,params).then((response)=>{
      // commit('set')
      console.log(response.data)
      return true;

    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Check Conflict');
      return false;
    });
  },

  setBookingsNull({commit}){
    commit('set_bookings_null');
  },

  transferBooking({commit},params){
    return axios.post(TRANSFER_BOOKED,params).then((response)=>{
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Transfer booked');
      return false;
    });
  },

  async getLatestReservationBookings({commit}, param) {
    return await axios.get(`${CREW_LATEST_BOOKING}/${param}`).then((response)=>{
      commit('set_reservation_bookings',response.data);
      console.log(response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get All Booking Details on Single Reservation.');
      return false;
    });
  },

  getAllBookingEncode({commit},params){
    return axios.post(GET_ALL_BOOKING_ENCODE,params).then((response)=>{
      commit('set_bookings',response.data.data);
      commit('set_tnkc_booked_pagination',response.data);
      return true;

    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get All Booking');
      return false;

    });
  },

  //todo
  viewBookingEncode({commit},params){
    console.log('demo',params);
    return axios.get(`${VIEW_BOOKING_ENCODE}`,{params}).then((response)=>{
      commit('set_booked',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'View Booking Encode');
      return false;
    });
  },

  updateBookingEncode({commit},params){
    console.log('this is in update actions',params);

    return axios.post(`${UPDATE_BOOKING_ENCODE}/${params.booking_id}`,params).then((response)=>{
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Update Booking Encode');
      return false;
    });
  },

  deleteBookingEncode({commit},params){
    return axios.delete(`${DELETE_BOOKING_ENCODE}/${params}`).then((response)=>{
      commit('set_delete_booked',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Delete Booking Encode');
      return false;
    });
  }

};

//getters
const getters = {
  booked: state => state.booked,
  bookings: state => state.bookings,
  newBooking: state => state.newBooking,
  reservation_bookings: state => state.reservation_bookings,

  //
  booked_check_out : state => {},
};

export default {state, actions, mutations, getters};


